var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.929 12.743c-.288.574-2.425 4.88-3.318 5.678-.479 0-.51-.19-.67-.637-.16-.447-.128-2.042-1.914-2.201-1.786-.16-3.03 2.839-.925 5.326 2.105 2.488 4.115 1.946 5.87.83 1.402-.893 3.327-4.37 4.113-5.997-.031.682-.019 2.247.287 3.063.383 1.02 1.436 2.233 2.999 2.297 1.562.063 2.71-2.233 2.774-3.126.064-.893-.095-1.722.67-.191.766 1.53 1.946 1.626 2.966 1.467 1.021-.16 2.488-2.615 3.668-4.083 1.18-1.467 2.84-1.53 3.509-1.53.669 0 2.04.286 2.04-1.66C31 10.033 29.788 10 27.173 10c-2.093 0-4.72 2.424-5.773 3.636-.298-1.095-1.231-3.317-2.584-3.444-1.352-.128-2.626 1.137-3.094 1.786-.52-.67-1.92-2.003-3.349-1.978-1.786.032-3.157 2.17-3.444 2.743z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbk);
export default __webpack_public_path__ + "static/media/CBK.175dcab3e9f0d0b31ac4be24b3960587.svg";
export { ForwardRef as ReactComponent };